import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import router from '@/router/router.js'
import axios from '@/assets/js/api'
import Vuex from 'vuex'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/common.css'


Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.prototype.$http = axios

//路由权限跳转
router.beforeEach((to, from, next) => {
  const userMessage=JSON.parse(localStorage.getItem('user'));
  if(!userMessage && to.path!=='/login'){
    next('/login');
  }else{
    next();
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
